import React from 'react';

import naat from './assets/logoNAAT_CouleurJAUNE_fit800.png';
import greenpeace from './assets/LOGO-GP-vert-RVB-300x47.png';
import fnh from './assets/Logo-fnh.png';
import oxfam from './assets/OX_OFR_VL_vert_RGB-225x300.png';


export default () => (
  <div id="gp-footer">
    <div class="gp-footer-container" >
      <div class="gp-footer-initiative">une initiative portée par</div>
      <div class="logos">
        <a href="https://notreaffaireatous.org/">
          <img src={naat} alt="" />
        </a>
        <a href="http://greenpeace.fr/">
          <img src={greenpeace} alt=""/>
        </a>
        <a href="http://www.fondation-nature-homme.org/">
          <img src={fnh} alt=""/>
        </a>
        <a href="https://www.oxfamfrance.org/">
          <img src={oxfam} alt=""/>
        </a>
      </div>
    </div>
    <div class="padtb10">
      <div class="gp-menu-footer-container">
        <div class="gp-footer-left">
          <ul class="social ads-social">
            <li class="facebook">
              <a target="_blank" href="https://www.facebook.com/laffairedusiecle.fr/" title="Facebook" rel="noopener noreferrer">
                <i class="icon-facebook">
                </i>
              </a>
            </li>
            <li class="twitter">
              <a target="_blank" href="https://twitter.com/laffairedusiecl" title="Twitter" rel="noopener noreferrer">
                <i class="icon-twitter">
                </i>
              </a>
            </li>
            <li class="instagram">
              <a target="_blank" href="https://www.instagram.com/affairedusiecle/" title="Instagram" rel="noopener noreferrer">
                <i class="icon-instagram">
                </i>
              </a>
            </li>
          </ul>
        </div>
        <div class="gp-footer-right">
          <ul>
            <li>
              <a href="https://laffairedusiecle.net/mentions-legales/">Mentions légales</a>
            </li>
            <li>
              <a href="https://laffairedusiecle.net/faq/">FAQ</a>
            </li>
            <li>
              <a href="https://laffairedusiecle.net/contact/">Contact</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
);
